var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.bannerList?.length)?_c('div',{staticClass:"japan-bottom-banner"},[_c(_setup.WphkBanner,{class:['main-banner'],attrs:{"type":"swiper","bannerList":_setup.bannerList,"isMultBrow":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }